import React from 'react'

const IconListen = ({color}) => {
    return (
        <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M47.4112 8C47.4112 3.58172 50.9929 0 55.4112 0H77.1398C81.5581 0 85.1398 3.58172 85.1398 8V8.66666C85.1398 13.0849 81.5581 16.6667 77.1398 16.6667H63.6168V77.8646H63.3636C62.6883 84.1146 60.0718 89.3663 55.514 93.6198C50.9562 97.8733 45.5543 100 39.3084 100C32.5561 100 26.8166 97.5694 22.0899 92.7083C17.3633 87.8472 15 81.9444 15 75C15 68.0556 17.3633 62.1528 22.0899 57.2917C26.8166 52.4306 32.5561 50 39.3084 50C41.8405 50 44.5414 50.5208 47.4112 51.5625V8Z" fill={color} />
        </svg>


    )
}

export default IconListen
